export default __webpack_public_path__ + "images/slide_6.jpeg?af3e244af58d824770ce9d90a070329a";